import { FunctionComponent } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { RowContainer } from '../container/common';
import { StyledElement } from '../types';

const BreadcrumbsContainer = styled(RowContainer)`
  justify-content: center;

  a,
  p {
    color: #000;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 18px;
    padding-right: 18px;
    font-weight: 400;
  }

  img {
    :last-child {
      display: none;
    }
  }
`;

export type BreadcrumbItem = {
  content: React.ReactNode;
  url: string;
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
} & StyledElement;

const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({
  className,
  items,
}) => {
  return (
    <BreadcrumbsContainer className={className}>
      {items.map(({ content, url }, index) => {
        const isLastItem = index === items.length - 1;

        if (isLastItem) {
          return <p>{content}</p>;
        }

        return (
          <>
            <Link href={url}>
              <a>{content}</a>
            </Link>
            <img src="https://res.cloudinary.com/givz/image/upload/v1658496617/production/shopify-app/chev_efjaoe.png" />
          </>
        );
      })}
    </BreadcrumbsContainer>
  );
};

export default Breadcrumbs;
